/* eslint-disable @typescript-eslint/no-var-requires */
const hiayConfig = require('hiya-common/config.js')
const package = require('./package.json')

module.exports = {
  project: package.name,
  devPort: 7100,
  devStaticPort: 7101,
  tracingOrigins: [
    'https://activity-hiya-web.mehiya.com/', // 根据H5 host来修改
    'http://me-hiya-web-activity-test.ixiaochuan.cn/', // 根据H5 host来修改
  ],
  ...hiayConfig,
}
